import React from 'react'
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import '../ContentSeo/TitleDivSeo.css'
// import { useContext } from 'react';
// import { StatusContext } from '../ContextApiStatus';

function TallLink(props) {


    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }



  return (
    <div>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <br /><br />
        <h3 style={{color:"#999999",textAlign:"right"}}>قابلية الاستخدام </h3>
        <br />
       <hr />
       <br />
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
         <h3>الرابط الخاص بك</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
          {props.url}
        </Typography>
        <Typography fontWeight="md" level="body-sm">
           طول الدومين الخاص بك هو {props.domainLength}
        </Typography>
      </CardContent>
      {props.domainLength >= 10 ? <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} /> :
      <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} /> }
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
          اجعل عناوين URL قصيرة وتجنب أسماء النطاقات الطويلة عندما يكون ذلك ممكنا.
يتم التعرف على عنوان URL الوصفي بشكل أفضل بواسطة محركات البحث.
يجب أن يكون المستخدم قادرا على إلقاء نظرة على شريط العناوين وإجراء تخمين دقيق حول محتوى الصفحة قبل الوصول إليها (على سبيل المثال ، http://www.mysite.com/en/products).
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
export default TallLink